var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"product-link",attrs:{"to":{ 
    name: 'supplier', 
    params: { supplierId: _vm.supplier.id } 
  }}},[_c('div',{staticClass:"supplier-card card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-title card-name"},[_vm._v(_vm._s(_vm.supplier.name))]),_c('br')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }